import { useContext, useMemo } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum } from '@/types/common';

export const useSelectedPaymentMethod = () => {
  const { paymentMethodSelected, otherMethodSelected } = useContext(CheckoutContext);

  return useMemo(
    () => ({
      selectedPaymentMethod:
        paymentMethodSelected === PaymentMethodEnum.OTHER ? otherMethodSelected : paymentMethodSelected,
    }),
    [paymentMethodSelected, otherMethodSelected]
  );
};
